import { render, staticRenderFns } from "./IcoPaperGraph.vue?vue&type=template&id=273bc838"
import script from "./IcoPaperGraph.vue?vue&type=script&lang=js"
export * from "./IcoPaperGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports